/**
 * External dependencies
 */
import { EMPTY_ARRAY } from '../constants';
import type { Url } from '@nab/types';

/**
 * Internal dependencies
 */
import type { State } from './types';

import { DEFAULT_SEGMENTATION_SETTINGS } from '../../public/utils/segmentation/segmentation-settings';

export const INIT_STATE: State = {
	position: 'top-right',
	gdprStatus: 'awaiting',
	status: { type: 'bootstrap', detail: 'awaiting-session' },
	cloudStatus: 'pending',
	tab: 'status',
	highlightedClick: undefined,
	settings: {
		api: { mode: 'native', url: '' as Url },
		cookieTesting: false,
		experiments: EMPTY_ARRAY,
		gdprCookie: { name: '', value: '' },
		heatmaps: EMPTY_ARRAY,
		homeUrl: '' as Url,
		maxCombinations: 24,
		segmentMatching: 'all',
	},
	cookies: {
		alternative: 0,
		segmentation: DEFAULT_SEGMENTATION_SETTINGS,
		views: {},
	},
	navigation: EMPTY_ARRAY,
	newCookies: {
		alternative: 0,
		segmentation: DEFAULT_SEGMENTATION_SETTINGS,
	},
};
